import { useState } from 'react'
import FavoriteStar from '../Components/FavoriteStar';
import { Modal } from 'react-bootstrap';
import { useConfig } from '../../Providers/ConfigProvider';

import './Styles/Slider.css'

const Slider = ({ product }) => {
  const [showModal, setShowModal] = useState(false)
  const [modalSlide, setModalSlide] = useState(null)
  const [current, setCurrent] = useState(0)
  const { dataUrl } = useConfig()

  if (!Array.isArray(product.photoFileNames) || product.photoFileNames.length <= 0) {
    return null
  }
  const handleImageClick = (slide) => {
    setModalSlide(slide)
    setShowModal(true)
  }

  return (<>
    <div className='d-flex justify-content-start'>
      <FavoriteStar
        isFavorite={product.isFavorite}
        index={product.index}
      />
    </div>
    <div className='slider col-12'>
      {product.photoFileNames && product.photoFileNames.map((item, index) => {
        return (
          <div
            className={index === current ? 'slide-product active' : 'slide-product'}
            key={index}
          >
            {index === current && (
              <img src={`${dataUrl}/miniaturki/${item}`} style={{ maxHeight: 200, maxWidth: 200, height: '100%', width: '100%' }} className='image' onClick={() => handleImageClick(`${dataUrl}/miniaturki/${item}`)}
                alt='' />
            )}
          </div>
        )
      })}

    </div>

    <div className='row slider-gallery justify-content-center' >
      {product.photoFileNames && product.photoFileNames.map((item, index) => {
        return <div key={index} className='col-2 slider-gallery-image' onClick={() => setCurrent(index)}>
          <img src={`${dataUrl}/miniaturki/${item}`} className='image-mini' alt='' />
        </div>
      })}
    </div>

    <Modal show={showModal} onHide={() => setShowModal(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>{product.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <img
          src={modalSlide}
          alt="Powiększone zdjęcie"
          style={{ width: '100%', height: 'auto', maxHeight: '70vh' }}
        />
      </Modal.Body>
    </Modal>
  </>)
}

export default Slider